import { LeftNavStyle } from "breadcommon";
import { Fragment, useContext, useState } from "react";
import { buildClasses } from "../utils/buildClasses";
import { BreadLogo } from "./BreadLogo";
import { MainNavButton, MainNavSettingsButton } from "./MainNavButton";
import { SyncControl } from "./SyncControl";
import { MAIN_NAV_ORDER } from "./mainNavDefinitions";
import { navRiseDelay } from "../rye/riseIn";
import { PreferencesContext } from "../firebaseio/PreferencesContext";

export function MainNavMenu() {
  const userPrefs = useContext(PreferencesContext);
  const navStyle = userPrefs.web.left_nav_style;
  const [syncMenuOpen, setSyncMenuOpen] = useState(false);

  return (
    <div
      data-expanded={syncMenuOpen || undefined}
      className={buildClasses(
        "h-full",
        "flex-shrink-0",
        "flex-grow-0",
        "overflow-hidden",
        "flex",
        "flex-col",
        "justify-between",
        "pl-2",
        "pr-2",
        "transition-[width]",
        "duration-200",
        "ease-out",
        "group/mainnav",
        "isolate", // create a stacking context so the main nav shows over the other stacking contexts
        "z-50",
        {
          switch: navStyle,
          cases: new Map<LeftNavStyle, string>([
            [LeftNavStyle.ALWAYS_COLLAPSED, "w-[3.25rem]"],
            [
              LeftNavStyle.EXPAND_ON_HOVER,
              syncMenuOpen
                ? "w-[10.25rem]"
                : buildClasses("w-[3.25rem]", "hover:w-[10.25rem]"),
            ],
            [LeftNavStyle.ALWAYS_EXPANDED, "w-[10.25rem]"],
          ]),
        },
      )}
    >
      <div className={buildClasses("flex", "flex-col")}>
        {/* Centres the 28px logo on the content's top bar: the panel's 8px
        inset and 1px border, plus half its 44px height, less half the logo. */}
        <div className="pt-[9px]" />
        <NavEntrance>
          <div className="pl-1">
            <BreadLogo />
          </div>
        </NavEntrance>
        <div className="h-5" />
        {MAIN_NAV_ORDER.map((screen, index) => (
          <Fragment key={screen}>
            {index > 0 && <MainNavButtonSpacer />}
            <NavEntrance>
              <MainNavButton mainNavScreen={screen} />
            </NavEntrance>
          </Fragment>
        ))}
      </div>
      <NavEntrance>
        <MainNavSettingsButton />
        <MainNavButtonSpacer />
        <SyncControl onMenuOpenChange={setSyncMenuOpen} />
      </NavEntrance>
    </div>
  );
}

/** Fades the nav in as the app first appears. */
function NavEntrance(props: { children: React.ReactNode }): JSX.Element {
  const [delay] = useState(navRiseDelay);
  return (
    <div
      className={buildClasses({
        if: delay !== null,
        then: "motion-safe:animate-nav-in",
      })}
      style={delay !== null ? { animationDelay: `${delay}ms` } : undefined}
    >
      {props.children}
    </div>
  );
}

function MainNavButtonSpacer(): JSX.Element {
  return <div className="h-3" />;
}
